import { createFileRoute, useParams } from '@tanstack/react-router';
import { Helmet } from 'react-helmet-async';
import { CheckInSettingsPage } from '@/features/check-in-settings/check-in-settings-page';
import { formatDocumentTitle } from '@/lib/document-title';
import { BusinessSetupPageShell } from './business-setup/components/business-setup-page-shell';

export const Route = createFileRoute('/_auth/$orgId/settings/check-in')({
  component: CheckInSettingsRoute,
});

function CheckInSettingsRoute() {
  const { orgId } = useParams({ from: '/_auth/$orgId/settings/check-in' });
  return (
    <>
      <Helmet defer={false}>
        <title>{formatDocumentTitle('Check-in')}</title>
      </Helmet>
      <BusinessSetupPageShell orgId={orgId} activePath="check-in" contentClassName="max-w-6xl">
        <CheckInSettingsPage routeOrgId={orgId} />
      </BusinessSetupPageShell>
    </>
  );
}
